import { render, staticRenderFns } from "./ProfitMargins.vue?vue&type=template&id=6d0798c8&scoped=true"
import script from "./ProfitMargins.vue?vue&type=script&lang=js"
export * from "./ProfitMargins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0798c8",
  null
  
)

export default component.exports